import {
	backgroundColor,
	blackColors,
	containerFluid,
	drawerMiniWidth,
	drawerWidth,
	hexToRgb,
	transition,
	whiteColor,
	grayColor,
	orangeLabelColor,
	colorNeutrals200,
} from 'assets/jss/material-dashboard-pro-react';

const appStyle = (theme) => ({
	languageSwitch: {
		height: 56,
		width: '100%',
		textAlign: 'right',
		backgroundColor: `rgba(${hexToRgb(whiteColor)}, 0.5)`,
		'& > div': {
			margin: '8px 28px 0 0',
			display: 'inline-block',
			'& > div': {
				display: 'flex',
				alignItems: 'center',
			},
		},
	},
	languageSwitchButton: {
		margin: '0 5px 0 0',
	},
	languageSwitchDivider: {
		marginRight: 5,
		width: 1,
		height: 16,
		backgroundColor: blackColors[4],
		display: 'inline-block',
	},
	helpIcon: {
		marginBottom: '2px',
	},
	footer: {
		padding: '24px 0 32px 40px',
		backgroundColor: '#5a5a5a',
		[theme.breakpoints.only('xs')]: {
			paddingLeft: 10,
		},
	},
	footerLinks: {
		display: 'flex',
		'& > div': {
			width: '100%',
		},
		[theme.breakpoints.down('sm')]: {
			display: 'block',
		},
	},
	contactUs: {
		margin: '0 40px 0 auto',
		textAlign: 'right',
		[theme.breakpoints.down('sm')]: {
			margin: '12px 0 0',
			textAlign: 'left',
		},
	},
	footerLinkHover: {
		'&:hover, &:hover > *': {
			transition: 'all 0.2s ease 0s',
			color: `${whiteColor}!important`,
		},
	},
	footerLink: {
		marginTop: 12,
		padding: '0 8px',
		fontSize: theme.fontSize(12),
		lineHeight: theme.fontSize(16),
		color: `rgba(${hexToRgb(whiteColor)}, 0.5)`,
		fontFamily: theme.fontFamily.albert.bold,
		borderRight: `1px solid rgba(${hexToRgb(whiteColor)}, 0.5)`,
		'&:first-of-type': {
			paddingLeft: 0,
			[theme.breakpoints.only('xs')]: {
				marginTop: 20,
			},
		},
		'&:last-of-type': {
			borderRight: 'none',
		},
		[theme.breakpoints.only('xs')]: {
			display: 'block',
			padding: 0,
		},
	},
	wrapper: {
		position: 'relative',
		backgroundColor: backgroundColor[0],
		top: '0',
		height: '100vh',
		'&:after': {
			display: 'table',
			clear: 'both',
			content: '" "',
		},
	},
	mainPanel: {
		transitionProperty: 'top, bottom, width',
		transitionDuration: '.2s, .2s, .35s',
		transitionTimingFunction: 'linear, linear, ease',
		[theme.breakpoints.up('md')]: {
			width: `calc(100% - ${drawerWidth}px)`,
		},
		overflow: 'auto',
		position: 'relative',
		float: 'right',
		...transition,
		width: '100%',
		overflowScrolling: 'touch',
		overflowY: 'hidden',
	},
	content: ({ isNewHeaderVisible }) => ({
		// header + margin + language switch header
		marginTop: isNewHeaderVisible ? 32 : 64 + 24,
		[theme.breakpoints.down('sm')]: {
			marginTop: isNewHeaderVisible ? 32 : 48 + 24,
			minHeight: isNewHeaderVisible ? 'calc(100vh - 450px)' : 'calc(100vh - 177px)',
		},
		[theme.breakpoints.down('xs')]: {
			marginTop: isNewHeaderVisible ? 32 : theme.direction === 'rtl' ? 88 + 56 : 48 + 16,
		},
		minHeight: isNewHeaderVisible ? 'calc(100vh - 450px)' : 'calc(100vh - 191px)',
		paddingBottom: 32,
	}),
	container: {
		...containerFluid,
		padding: '0 !important',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginLeft: 40,
		marginRight: 40,
		[theme.breakpoints.down('sm')]: {
			marginLeft: 16,
			marginRight: 16,
		},
	},
	map: {
		marginTop: '70px',
	},
	mainPanelSidebarMini: {
		[theme.breakpoints.up('md')]: {
			width: `calc(100% - ${drawerMiniWidth}px)`,
		},
	},
	mainPanelWithPerfectScrollbar: {
		overflow: 'hidden !important',
	},
	// EBU footer start
	footerGrid: {
		marginBottom: '16px',
		[theme.breakpoints.down('xs')]: {
			borderBottom: `1px solid rgba(${hexToRgb(whiteColor)}, 0.5)`,
		},
		[theme.breakpoints.up('sm')]: {
			paddingRight: '12px',
		},
	},
	footerBox: {
		backgroundColor: grayColor[20],
		color: whiteColor,
		padding: '32px 0',
		[theme.breakpoints.up('sm')]: {
			padding: '26px 0',
		},
	},
	footerContainer: {
		padding: '0 20px',
		[theme.breakpoints.up('sm')]: {
			padding: '0',
		},
	},
	supportPhone: {
		padding: '0 8px',
		fontFamily: theme.fontFamily.albert.regular,
	},
	businessCentre: {
		fontFamily: theme.fontFamily.albert.regular,
		color: colorNeutrals200,
	},
	footerLinkHead: {
		padding: '8px 0',
		fontFamily: theme.fontFamily.albert.bold,
		[theme.breakpoints.up('sm')]: {
			fontSize: theme.fontSize(16),
		},
	},
	footerEBULink: {
		padding: '8px 0',
		'&:last-of-type': {
			marginBottom: '16px',
		},
		fontFamily: theme.fontFamily.albert.regular,
		[theme.breakpoints.up('sm')]: {
			padding: '6px 0',
		},
		'&:hover,&:focus': {
			boxShadow: '0 0 0 0.25rem rgba(' + hexToRgb(orangeLabelColor) + ', 0.25)',
		},
	},
	footerOTC: {
		padding: '8px 0',
		fontFamily: theme.fontFamily.albert.regular,
		[theme.breakpoints.up('sm')]: {
			display: 'inline',
			marginLeft: '10px',
		},
	},
	footerOmanLogo: {
		display: 'block',
		padding: '8px 0',
		[theme.breakpoints.up('sm')]: {
			display: 'inline',
			paddingRight: '12px',
		},
		'&:hover,&:focus': {
			boxShadow: '0 0 0 0.25rem rgba(255, 120, 0, 0.25)',
		},
	},
	socialLink: {
		padding: '8px',
		marginRight: '16px',
		marginBottom: '8px',
		display: 'inline-block',
		'&:hover,&:focus': {
			boxShadow: '0 0 0 0.25rem rgba(255, 120, 0, 0.25)',
		},
	},
	reverseMenuContact: {
		[theme.breakpoints.up('sm')]: {
			flexDirection: 'row-reverse',
		},
	},
	// EBU footer end
});

export default appStyle;
